module.exports = __webpack_public_path__ + "static/one-percent-swiper_img01_m-09734c1e6366aa523729d3b3e07135d8.jpg";